import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { Globals } from '@core/globals';
import { RoutingData } from '@core/routing-data';
import { LanguageService } from '@services/language.service';
import { SsrService } from '@services/ssr.service';

declare var Cookies: any;
declare const masterLayer: any;

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  private title = inject(Title);
  private globals = inject(Globals);
  private languageService = inject(LanguageService);
  private ssrService = inject(SsrService);
  private activatedRoute = inject(ActivatedRoute);

  pushGtm(data: any): void {
    if ((typeof Cookies !== 'undefined' && Cookies.get('ah-cookie-analytics') !== '1') || this.ssrService.isServer()) return;
    data.lang = this.languageService.language();
    masterLayer.push(data);
  }

  pushGtmPageType(data: any): void {
    data.pageType = this.getPageType();
    this.pushGtm(data);
  }

  pushGtmLandingPage(data: any): void {
    if (this.ssrService.isServer()) return;
    data = this.setLandingPageData(data);
    this.pushGtm(data);
  }

  pushGtmDataPage(data: any): void {
    if (this.ssrService.isServer()) return;
    data = this.setLandingPageData(data);
    setTimeout(() => {
      this.pushGtm(data);
    }, 250);
  }

  setLandingPageData(data: any) {
    if (data === undefined) data = {};
    data.event = data.event ?? 'page_view';
    data.pageUrl = window.location.pathname?.split('#')[0];
    data.page_location = window.location.pathname?.split('#')[0];
    data.page_referrer = sessionStorage.getItem('prevPage') ? `${sessionStorage.getItem('prevPage')}` : undefined;
    data.pageType_referrer = sessionStorage.getItem('pageTypeReferrer') ? `${sessionStorage.getItem('pageTypeReferrer')}` : undefined;
    data.pageTitle = this.title.getTitle();
    data.pageType = this.getPageType();
    return data;
  }

  loadUtm(): void {
    if (typeof Cookies === 'undefined' || this.ssrService.isServer()) return;
    const utmSource: string | null = this.activatedRoute.snapshot.queryParamMap.get('utm_source');
    const utmMedium: string | null = this.activatedRoute.snapshot.queryParamMap.get('utm_medium');
    const utmContent: string | null = this.activatedRoute.snapshot.queryParamMap.get('utm_content');
    const utmCampaign: string | null = this.activatedRoute.snapshot.queryParamMap.get('utm_campaign');
    const referer: string | null = this.activatedRoute.snapshot.queryParamMap.get('referer');
    let domain: string | string[] = window.location.href;
    domain = domain.split('/')[2];
    domain = domain.split('.');
    if (domain.length > 1) {
      let domainSecond: string[] = domain[domain.length - 1].split(':');
      domain = '.' + domain[domain.length - 2] + '.' + domainSecond[0];
    } else {
      domain = domain[domain.length - 1];
    }

    if (utmSource) Cookies.set('utm_source', utmSource, { expires: 90, path: '/', domain: domain });
    if (utmMedium) Cookies.set('utm_medium', utmMedium, { expires: 90, path: '/', domain: domain });
    if (utmContent) Cookies.set('utm_content', utmContent, { expires: 90, path: '/', domain: domain });
    if (utmCampaign) Cookies.set('utm_campaign', utmCampaign, { expires: 90, path: '/', domain: domain });
    if (referer) Cookies.set('referer', referer, { expires: 90, path: '/', domain: domain });
  }

  getPageType(): string | undefined {
    if (this.ssrService.isServer()) return;
    const url: string = '/' + window.location.pathname?.split('/')[1].split('?')[0].split('#')[0];
    for (let [key, value] of Object.entries(this.globals.routes())) {
      if (value.url === url && value.pageType) return value.pageType;
    }
    return RoutingData.pageTypeDefault;
  }
}
